import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueRouter from "vue-router";
import store from "./store";
import Buefy from "buefy";
import "./assets/scss/app.scss";
import VueScrollTo from "vue-scrollto";

import { library } from "@fortawesome/fontawesome-svg-core";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faGoogle, faWhatsapp, faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";

// internal icons
import {
  faStar,
  faPhoneAlt,
  faInfoCircle,
  faPlay,
  faMapMarkerAlt,
  faClock,
  faSignal,
  faFileSignature,
  faCalendarAlt,
  faPlus,
  faTerminal,
  faLink,
  faChevronLeft,
  faFlag,
  faTasks,
  faCheck,
  faUserCircle,
  faChartLine,
  faSignOutAlt,
  faBell,
  faCog,
  faCheckCircle,
  faHeart,
  faDice,
  faMobile,
  faRupeeSign,
  faCaretRight,
  faCaretDown,
  faExclamationTriangle,
  faAngleLeft,
  faAngleRight
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngleLeft,
  faAngleRight,
  faStar,
  faPhoneAlt,
  faInstagram,
  faFacebook,
  faWhatsapp,
  faGoogle,
  faInfoCircle,
  faPlay,
  faSignal,
  faClock,
  faMapMarkerAlt,
  faCalendarAlt,
  faFileSignature,
  faPlus,
  faTerminal,
  faLink,
  faChevronLeft,
  faFlag,
  faTasks,
  faCheck,
  faChartLine,
  faHeart,
  faUserCircle,
  faSignOutAlt,
  faBell,
  faCog,
  faCheckCircle,
  faDice,
  faMobile,
  faRupeeSign,
  faCaretRight,
  faCaretDown,
  faExclamationTriangle
);

window.eventBus = new Vue();

Vue.config.productionTip = false;


Vue.component("vue-fontawesome", FontAwesomeIcon);

Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: ""
    },
    far: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: ""
    },
    fab: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: ""
    }
  }
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: "home"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.loggedIn) {
      next({
        name: "dashboard"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
